module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"go-to-top":"go to top","notFound":"No Results Found","categoryNotFound":"Category Not Found"},"de":{"go-to-top":"Seitenanfang\\"","notFound":"Keine Ergebnisse Gefunden","categoryNotFound":"Kategorie nicht gefunden"}}')
  delete Component.options._Ctor
}
